var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"position":"absolute","width":"100%","height":"97%"},attrs:{"src":_vm.frameSrc,"frameborder":"0"},on:{"load":_vm.onFrameLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }